import React, { useState, useEffect } from 'react'
import * as api from '../../services/api.js'
import Card from '../../components/Card.jsx'
import TipBox from '../../components/TipBox.jsx'

export default function WorldBuilding({ pid = 'w' }) {
  const [project, setProject] = useState({})
  useEffect(() => { api.getWritingProjectData(pid).then(d => setProject(d || {})) }, [pid])
  function set(field, value) {
    setProject(prev => {
      const next = { ...prev, [field]: value }
      api.saveWritingProjectData(pid, next)
      return next
    })
  }

  return (
    <Card label="Section 3" title="The world">
      <TipBox title="💡 Building your setting" collapsible>
        <p>Setting is not backdrop — it's atmosphere, pressure, and possibility. The best settings feel alive because they have rules, history, and texture. Even if your story is set in a recognisable city, ask: <em>what is specific about this place at this time?</em></p>
        <ul>
          <li><strong>Realism</strong> — even fantasy worlds need internal consistency. If magic exists, what are its costs?</li>
          <li><strong>Sensory anchoring</strong> — pick 2–3 recurring sensory details that make your world instantly recognisable</li>
          <li><strong>Social texture</strong> — class, power, history all shape how characters move through space</li>
        </ul>
      </TipBox>

      <div className="w-form" style={{ marginTop: '1.25rem' }}>
        <div>
          <label className="w-label">Time period</label>
          <input className="w-input"
            placeholder="e.g. Contemporary, 1940s London, far future..."
            value={project.period || ''}
            onChange={e => set('period', e.target.value)}
          />
        </div>
        <div>
          <label className="w-label">Primary location(s)</label>
          <input className="w-input"
            placeholder="e.g. A crumbling country house, a generation ship..."
            value={project.location || ''}
            onChange={e => set('location', e.target.value)}
          />
        </div>
        <div className="full">
          <label className="w-label">World rules & atmosphere (what makes this world specific?)</label>
          <textarea className="w-textarea" rows={3}
            placeholder="Describe the feel, rules, and texture of your world..."
            value={project.world || ''}
            onChange={e => set('world', e.target.value)}
          />
        </div>
        <div className="full">
          <label className="w-label">Three sensory anchors (recurring details that define this world)</label>
          <input className="w-input"
            placeholder="e.g. The smell of coal smoke, the sound of a particular church bell, grey winter light..."
            value={project.senses || ''}
            onChange={e => set('senses', e.target.value)}
          />
        </div>
      </div>

      <TipBox title="Making your world feel real" collapsible>
        <ul>
          <li>Every world has rules. Write down three things that are impossible in your world and three things that are inevitable.</li>
          <li>What does this world smell like? Sound like at 3am? What do people eat for breakfast?</li>
          <li>What happened here fifty years ago that still shapes how people behave today?</li>
          <li>What does your world want — what is it moving toward or away from?</li>
        </ul>
      </TipBox>
    </Card>
  )
}
